import React, { useEffect, useState } from 'react';
import { Loader2, Building2, FileSpreadsheet } from 'lucide-react';
import { coworkForestaApi } from '../../lib/api';
import { LiquidacionTrimestralTable } from '../../components/cowork/LiquidacionTrimestralTable';

export default function PropietarioCowork() {
  const [loading, setLoading] = useState(true);
  const [liquidaciones, setLiquidaciones] = useState([]);
  const [sel, setSel] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const res = await coworkForestaApi.misLiquidacionesTrimestrales();
        const liqs = res.data?.liquidaciones || [];
        setLiquidaciones(liqs);
        if (liqs.length > 0) setSel(`${liqs[0].edificio_id}__${liqs[0].trimestre_key}`);
      } catch (err) {
        setLiquidaciones([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const current = liquidaciones.find((l) => `${l.edificio_id}__${l.trimestre_key}` === sel);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64 text-slate-500" data-testid="prop-cowork-loading">
        <Loader2 className="w-5 h-5 animate-spin mr-2" /> Cargando…
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto px-4 py-6 space-y-5" data-testid="prop-cowork-page">
      <div className="flex items-center gap-2">
        <FileSpreadsheet className="w-5 h-5 text-emerald-600" />
        <h1 className="text-xl font-semibold text-slate-900">Cowork — Liquidación Trimestral</h1>
      </div>

      {liquidaciones.length === 0 ? (
        <div className="bg-white rounded-lg border border-slate-200 py-16 text-center" data-testid="prop-cowork-empty">
          <Building2 className="w-8 h-8 text-slate-300 mx-auto mb-3" />
          <p className="text-sm text-slate-500">Todavía no hay rendiciones trimestrales publicadas para tu pool Cowork.</p>
        </div>
      ) : (
        <>
          <div className="flex flex-wrap items-center gap-3">
            <label className="text-xs font-medium uppercase tracking-wider text-slate-500">Trimestre</label>
            <select
              value={sel}
              onChange={(e) => setSel(e.target.value)}
              className="h-9 rounded-md border border-slate-200 bg-white px-3 text-sm font-medium text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-500/30"
              data-testid="prop-cowork-selector"
            >
              {liquidaciones.map((l) => (
                <option key={`${l.edificio_id}__${l.trimestre_key}`} value={`${l.edificio_id}__${l.trimestre_key}`}>
                  {l.edificio_nombre ? `${l.edificio_nombre} · ` : ''}{l.trimestre_label || l.trimestre_key}
                </option>
              ))}
            </select>
          </div>

          {current && (
            <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-4 space-y-3">
              <div className="flex flex-wrap gap-x-8 gap-y-1 text-sm border-b border-slate-100 pb-3">
                <div><span className="text-slate-500">Trimestre: </span><b className="text-slate-800">{current.trimestre_label || current.trimestre_key}</b></div>
                <div><span className="text-slate-500">Rendición: </span><b className="text-slate-800">{current.rendicion_label || '—'}</b></div>
                <div><span className="text-slate-500">Fee de gestión GCSAS: </span><b className="text-slate-800">{current.fee_pct}%</b></div>
              </div>
              <LiquidacionTrimestralTable
                filas={current.filas}
                feePct={current.fee_pct}
                mesesLabels={current.meses_labels}
                editable={false}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}
